<template>
  <MainLayout>
    <!--    style="background-color: yellow;   margin-right: auto;   margin-left: -15%; width: 120%; border: 3px solid green; overflow-y: scroll;" -->
    <div>
      <!--<b-card
        id="gavService-Branches"
        class="shadow-sm mb-4 BranchesEditor cardStyle"
      >
        <h4
          class="card-title font-weight-bold"
          style="margin-bottom: 40px"
        >
          GAV-Service/LSE
        </h4>
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />
        <b-card-body>
          <u-loader v-if="isGavServiceLoading" />
          <b-row v-else>
            <b-col
              class="mb-4"
              cols="4"
            >
              <branch-search-list
                :all-branches="allGavServiceBranches"
                :selected-item-id="selectedGavServiceBranche"
                @selectedItemChanged="gavServiceBrancheselectedItemChanged"
              />
            </b-col>
            <b-col
              class="mb-8"
              cols="8"
            >
              <branch-edit-view-form
                :all-noga-branches="allNogaBranches"
                :custom-branch-type-id="1"
                :field="gavServiceSelectedItem"
                anchor-id="gavService-Branches"
                @itemsChanged="branchesItemsChanged"
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>-->
      <b-card
        id="unia-Branches"
        class="shadow-sm mb-4 cardStyle"
      >
        <h4
          class="card-title font-weight-bold"
          style="margin-bottom: 40px"
        >
          Unia
        </h4>
        <b-card-body>
          <u-loader v-if="isUniaLoading" />
          <b-row v-else>
            <b-col
              class="mb-4"
              cols="4"
            >
              <branch-search-list
                :all-branches="allUniaBranches"
                :selected-item-id="selectedUniaBranche"
                @selectedItemChanged="uniaBrancheselectedItemChanged"
              />
            </b-col>
            <b-col
              class="mb-8"
              cols="8"
            >
              <branch-edit-view-form
                :all-noga-branches="allNogaBranches"
                :custom-branch-type-id="2"
                :field="uniaSelectedItem"
                anchor-id="unia-Branches"
                @itemsChanged="branchesItemsChanged"
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-card
        id="lse-Branches"
        class="shadow-sm cardStyle"
      >
        <h4
          class="card-title font-weight-bold"
          style="margin-bottom: 40px"
        >
          tempdata
        </h4>
        <b-card-body>
          <u-loader v-if="isLseLoading" />
          <b-row v-else>
            <b-col
              class="mb-4"
              cols="4"
            >
              <branch-search-list
                :all-branches="allLSEBranches"
                :selected-item-id="selectedLseBranche"
                @selectedItemChanged="lseBrancheselectedItemChanged"
              />
            </b-col>
            <b-col
              class="mb-8"
              cols="8"
            >
              <branch-edit-view-form
                :all-noga-branches="allNogaBranches"
                :custom-branch-type-id="3"
                :field="lseSelectedItem"
                anchor-id="lse-Branches"
                @itemsChanged="branchesItemsChanged"
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import BranchSearchList from "@/components/branches/BranchSearchList.vue";
import BranchEditViewForm from "@/components/branches/BranchEditViewForm.vue";
import { MultiLangMixin } from "@/mixins/MultilanguageContentsMixin";
import { GetAllBranches, GetBranchesIds } from "@/services/Branches.service.js";
import { GetAllNogaBranches } from "@/services/nogaBranches.service.js";

export default {
  components: {
    MainLayout,
    BranchSearchList,
    BranchEditViewForm,
  },
  mixins: [MultiLangMixin],
  data() {
    return {
      customBranchesIds: null,
      allGavServiceBranches: [],
      allUniaBranches: [],
      allLSEBranches: [],
      allNogaBranches: [],
      isGavServiceLoading: false,
      isUniaLoading: false,
      isLseLoading: false,
      selectedGavServiceBranche: null,
      selectedUniaBranche: null,
      selectedLseBranche: null,
      gavServiceSelectedItem: null,
      uniaSelectedItem: null,
      lseSelectedItem: null,
      errorObject: null,
    };
  },
  created() {
    this.errorObject = null;
    this.isLoading = true;
    this.loadAllNogaBranches();
  },

  methods: {
    loadAllNogaBranches(customBranchTypeId) {
      if (!customBranchTypeId || customBranchTypeId == 1) {
        this.isGavServiceLoading = true;
      }

      if (!customBranchTypeId || customBranchTypeId == 2) {
        this.isUniaLoading = true;
      }

      if (!customBranchTypeId || customBranchTypeId == 3) {
        this.isLseLoading = true;
      }

      this.errorObject = null;

      GetAllNogaBranches(
        (response) => {
          this.allNogaBranches = response;

          GetBranchesIds(
            (branchesIds) => {
              this.customBranchesIds = branchesIds;

              GetAllBranches(
                (success) => {
                  success = success.sort((a, b) => {
                    if (a.code.toLowerCase() < b.code.toLowerCase()) {
                      return -1;
                    }
                    if (a.code.toLowerCase() > b.code.toLowerCase()) {
                      return 1;
                    }
                    return 0;
                  });

                  // remove this once backend returns correct result
                  var correctedItems = [];

                  success.map((item) => {
                    var tempItem = correctedItems.filter((itemToFilter) => {
                      return itemToFilter.customBranchId == item.customBranchId;
                    });

                    if (tempItem.length == 0) {
                      correctedItems.push(item);
                    }
                  });

                  if (!customBranchTypeId || customBranchTypeId == 1) {
                    this.allGavServiceBranches = correctedItems.filter(
                      (customBranch) => {
                        return customBranch.customBranchTypeId == 1;
                      },
                    );
                  }

                  if (!customBranchTypeId || customBranchTypeId == 2) {
                    this.allUniaBranches = correctedItems.filter(
                      (customBranch) => {
                        return customBranch.customBranchTypeId == 2;
                      },
                    );
                  }

                  if (!customBranchTypeId || customBranchTypeId == 3) {
                    this.allLSEBranches = correctedItems.filter(
                      (customBranch) => {
                        return customBranch.customBranchTypeId == 3;
                      },
                    );
                  }

                  this.isGavServiceLoading = false;
                  this.isUniaLoading = false;
                  this.isLseLoading = false;
                },
                (error) => {
                  this.isGavServiceLoading = false;
                  this.isUniaLoading = false;
                  this.isLseLoading = false;
                  this.errorObject = error;
                },
              );
            },
            (error) => {
              this.errorObject = error;
              this.isGavServiceLoading = false;
              this.isUniaLoading = false;
              this.isLseLoading = false;
            },
          );
        },
        (error) => {
          this.isGavServiceLoading = false;
          this.isUniaLoading = false;
          this.isLseLoading = false;
          this.errorObject = error;
        },
      );
    },
    gavServiceBrancheselectedItemChanged(selectedItem) {
      this.gavServiceSelectedItem = selectedItem;
    },
    uniaBrancheselectedItemChanged(selectedItem) {
      this.uniaSelectedItem = selectedItem;
    },
    lseBrancheselectedItemChanged(selectedItem) {
      this.lseSelectedItem = selectedItem;
    },
    branchesItemsChanged(customBranchesTypId, previousSelectedId) {
      this.loadAllNogaBranches(customBranchesTypId);
      if (previousSelectedId) {
        switch (customBranchesTypId) {
          case 1:
            this.selectedGavServiceBranche = previousSelectedId;
            break;
          case 2:
            this.selectedUniaBranche = previousSelectedId;
            break;
          case 3:
            this.selectedLseBranche = previousSelectedId;
            break;
          default:
            break;
        }
      }
    },
  },
};
</script>

<style scoped>
.cardStyle {
  width: 120%;
  margin-left: -10%;
}
</style>
